import { createSelector } from 'reselect';
import UserStore from '../../../../stores/UserStore';

const goalEntries = (state) => state.goalEntries.list;

export const getLocales = createSelector(
    goalEntries,
    (goalEntries = []) => {
        let list = [];

        goalEntries.map((item) => {
            item.offer.locales.map((locale) => {
                if (list.findIndex((item) => item.value === locale) === -1) {
                    list.push({
                        value: locale,
                        title: locale
                    });
                }
            });
        });

        return list;
    }
);

export const getAccess = createSelector(
    () => {
        const staticNames = UserStore.getTranslation().offersPage.goalsList;
        return [
            {
                title: staticNames.accessible,
                value: '1',
            },
            {
                title: staticNames.inaccessible,
                value: '0',
            },
        ];
    }
);
